import type { LocalDate } from '@zg-rentals/ts-customer-analytics-client';

const formatDateRange = (start: Date, end: Date): string => {
  const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
  const endMonth = end.toLocaleDateString('en-US', { month: 'short' });
  const startDay = start.getDate();
  const endDay = end.getDate();

  if (start.getTime() === end.getTime()) {
    return `${startMonth} ${startDay}`;
  }

  if (start.getMonth() === end.getMonth()) {
    return `${startMonth} ${startDay}–${endDay}`;
  }

  return `${startMonth} ${startDay} – ${endMonth} ${endDay}`;
};

export const formatSpotlightDates = (dates: Array<LocalDate> | undefined): Array<{ range: string; count: number }> => {
  if (!dates || dates.length === 0) return [];

  const sortedDates = dates.map((d) => new Date(d.year, d.month - 1, d.day)).sort((a, b) => a.getTime() - b.getTime());

  const ranges: Array<{ range: string; count: number }> = [];
  let start = sortedDates[0];
  let end = sortedDates[0];
  let count = 1;

  for (let i = 1; i < sortedDates.length; i++) {
    const current = sortedDates[i];
    const prevDate = new Date(end);
    prevDate.setDate(prevDate.getDate() + 1);

    if (current.getTime() === prevDate.getTime()) {
      end = current;
      count++;
    } else {
      ranges.push({
        range: formatDateRange(start, end),
        count,
      });
      start = current;
      end = current;
      count = 1;
    }
  }

  ranges.push({
    range: formatDateRange(start, end),
    count,
  });

  return ranges;
};
